/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.coupons.controllers', [
    'acme.common.service.api'
])

.controller('CouponsController', ['$scope', 'ApiService', function($scope, ApiService) {

    $scope.coupons = {

      model: {},

      init: function() {
          // Sets the titlebar
          $scope.$emit('Application::contentTitleChange', {
              title: 'Coupons'
          });
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.coupons.init();

}]);